export const SEARCH_REQUEST=`search/request`;
export const SEARCH_SUCCESS=`search/success`;
export const SINGLE_PRODUCT_SUCCESS=`singleproduct/success`;
export const SUBCATEGORY_SUCCESS=`subcategory/success`;
export const SEARCH_ERROR=`search/error`;
